import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material'
import { Warning as WarningIcon } from '@mui/icons-material'
import { Empresa } from '../../types/api'

interface DeleteConfirmDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => Promise<void>
  empresa: Empresa | null
  loading?: boolean
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  empresa,
  loading = false,
}) => {
  const { t } = useTranslation()
  const handleConfirm = async () => {
    try {
      await onConfirm()
      onClose()
    } catch (error) {
      // Erro já é tratado pelo componente pai via onError
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="warning" />
          <Typography variant="h6">{t('common.deactivate', 'Inativar')}</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t('companies.deactivateConfirm', 'Deseja inativar a empresa')} <strong>"{empresa?.nome}"</strong>?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {t('companies.deactivateWarning', 'A empresa ficará indisponível para novos acessos, mas os dados serão preservados para auditoria.')}
        </Typography>
        {empresa && (
          <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
            <Typography variant="caption" color="text.secondary" display="block">
              <strong>{t('companies.cnpj')}:</strong> {empresa.cnpj || '-'}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block">
              <strong>{t('companies.database')}:</strong> {empresa.banco_dados || '-'}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block">
              <strong>{t('companies.ip')}:</strong> {empresa.ip || '-'}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t('common.cancel')}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="warning"
          disabled={loading}
        >
          {loading ? t('common.loading') : t('common.deactivate', 'Inativar')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteConfirmDialog


